/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Backpac API
 * The Backpac API description
 * OpenAPI spec version: 1.0
 */

export type TaxInfoType = typeof TaxInfoType[keyof typeof TaxInfoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaxInfoType = {
  'W-9': 'W-9',
  'W-8BEN': 'W-8BEN',
  'W-8BEN-E': 'W-8BEN-E',
  UPLOAD: 'UPLOAD',
} as const;
